import { component } from 'picoapp';
import Headroom from 'headroom.js';

class SiteHeader {
  constructor(el, ctx) {
    this.el = el;
    this.init();
  }
  init() {
    var headroom = new Headroom(this.el);
    headroom.init();
  }
}

export default component((node, ctx) => {
  new SiteHeader(node, ctx);
  // class SiteHeader extends HTMLElement {
  //   constructor() {
  //     super();
  //   }
  //   connectedCallback() {
  //     var headroom = new Headroom(this);
  //     headroom.init();
  //   }
  // }

  // if (!customElements.get('site-header')) {
  //   customElements.define('site-header', SiteHeader);
  // }
});
